module.exports = __webpack_public_path__ + "img/Logo Segmentation_Blue_Circle.0de1eb30.png";